import { render, staticRenderFns } from "./cate-dialog.vue?vue&type=template&id=6a772cf0&"
import script from "./cate-dialog.vue?vue&type=script&lang=js&"
export * from "./cate-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cate-dialog.vue"
export default component.exports